import { document, window } from "browser-monads"
import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { ThemeUtils } from "../utils/ThemeUtils"

const { localStorage } = window

var current_font_size = 100;
var showonly_option = "1";

const DivShareWeb = styled.div`
  // display: none;
  text-align: center;
  /*width: 300px;height: fit-content;background: white;*/
  background: white;
  position: absolute;
  right: 0;
  top: 0;
  // margin-top: 80px;
  background-color: #ffffff;
  height: fit-content;
  width: fit-content;
  height: 200px;
  width: 300px;
  border-radius: 29px;
  /*-moz-box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);
  box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);*/
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.5);
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 10px;
`

function reduce_font_size() {
  if (window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: "Option",
      eventAction: "change font",
      eventLabel: "reduce",
    })
  }

  if (parseInt(localStorage.getItem("font_size")) <= 40) return
  current_font_size = parseInt(localStorage.getItem("font_size")) - 5
  localStorage.setItem("font_size", current_font_size)
  document.getElementById("font_range").value = current_font_size
  ThemeUtils.set_font_color('font_size')
}

function set_font_size(size) {
  if (window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: "Option",
      eventAction: "change font",
      eventLabel: "set",
    })
  }

  current_font_size = size;
  localStorage.setItem("font_size", current_font_size);
  ThemeUtils.set_font_color('font_size');
}


function enlarge_font_size() {
  if (window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: "Option",
      eventAction: "change font",
      eventLabel: "enlarge",
    })
  }

  if (parseInt(localStorage.getItem("font_size")) >= 180) return;

  current_font_size = parseInt(localStorage.getItem("font_size")) + 5;

  localStorage.setItem("font_size", current_font_size);
  document.getElementById("font_range").value = current_font_size;
  ThemeUtils.set_font_color('font_size');
}

function FontSizeButton() {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [currentFontSize, setCurrentFontSize] = useState(100)
  const node = useRef()

  useLayoutEffect(() => {
    var current_font_size = 100
    if (localStorage.getItem("font_size") !== null) {
      current_font_size = parseInt(localStorage.getItem("font_size"))
    } else {
      localStorage.setItem("font_size", current_font_size)
    }
    if (document.getElementById("font_range")) {
      document.getElementById("font_range").innerHTML = current_font_size
      document.getElementById("font_range").value = current_font_size
    }
    setCurrentFontSize(current_font_size)
  }, [setCurrentFontSize])

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      return
    }
    setIsOpenModal(false)
  }

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick)
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick)
    }
  }, [])

  function openModal() {
    setIsOpenModal(!isOpenModal)
  }

  return (
    <div ref={node}>
      <div
        role="button"
        tabIndex="0"
        id={"newmag_social_share_web_font_size"}
        className="newmag_social_share_web"
        style={{ cursor: "pointer", display: "inline-block" }}
        alt="Font size article"
        onClick={() => openModal()}
        onKeyDown={(event) => {
          if (event.key === "Enter") openModal()
        }}
      >
        <img
          className="icon_font_size share_icons"
          alt="Font size article"
          src="/img/font_resize@2x.png"
          style={{ marginTop: "7px", width: "27px", height: "auto" }}
        />
      </div>
      {!isOpenModal ? (
        ""
      ) : (
        <div style={{ position: "relative" }}>
          <DivShareWeb
            id={"div_shareeweb_font_size"}
            className="div_shareeweb"
            style={{ zIndex: "2" }}
          >
            <div
              className="div_font_size"
              style={{
                display: "flex",
                position: "relative",
                top: 0,
                right: 0,
              }}
            >
              <div style={{ width: "100%", margin: "auto", display: "flex" }}>
                <div style={{ width: "0%", margin: "auto" }} />
                <div
                  style={{ cursor: "pointer", width: "15%", margin: "auto" }}
                  onClick={() => reduce_font_size()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                      reduce_font_size()
                    }
                  }}
                  role="button"
                  tabIndex="0"
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      margin: "auto",
                      fontWeight: "500",
                    }}
                  >
                    - A
                  </h2>
                </div>
                <div style={{ cursor: "pointer", width: "50%" }}>
                  <div
                    style={{
                      display: "block",
                      marginTop: showonly_option ? "-44px" : "-16px",
                      marginBottom: "-28px",
                      width: "",
                      textAlign: "center",
                    }}
                  >
                    <p
                      id={"div_fontsize_text_font_size"}
                      style={{ fontSize: showonly_option ? "20px" : "14px" }}
                    >
                      {localStorage.getItem("font_size") + "%"}
                    </p>
                  </div>
                  <input
                    step="5"
                    onChange={(event) => {
                      setCurrentFontSize(event.target.value)
                      set_font_size(event.target.value)
                    }}
                    id="font_range"
                    type="range"
                    name="fontsize"
                    min="40"
                    max="180"
                    value={currentFontSize}
                  />
                </div>
                <div
                  style={{ cursor: "pointer", width: "10%", margin: "auto" }}
                  onClick={() => enlarge_font_size()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                      enlarge_font_size()
                    }
                  }}
                  tabIndex="0"
                  role="button"
                >
                  <h2
                    style={{
                      fontSize: "30px",
                      margin: "auto",
                      fontWeight: "700",
                    }}
                  >
                    A+
                  </h2>
                </div>
                <div style={{ width: "5%", margin: "auto" }} />
              </div>
            </div>
          </DivShareWeb>
        </div>
      )}
    </div>
  )
}

export default FontSizeButton
